import React from "react";
import TestReportsLayout from "../components/testreports/TestReportsLayout";

/** Tester's own test reports list. */
function TesterReports() {
  return <TestReportsLayout variant="tester" />;
}

export default TesterReports;
